import React from "react";
import content from "../../constants/en"

export default function Footer() {
  const copy = content.confirmSmartCode

  return (
    <>
      {copy.footerMessage}
    </>
  );
}
